import React from 'react';
import PropTypes from 'prop-types';
import { ButtonInputClear } from 'components/buttons';
import { Close } from 'components/SvgIcons';
import { CFM_VOLCANO } from 'constants/Colors';
import TextareaAutosize from 'react-textarea-autosize';
import './styles.scss';

/**
 * Input TextArea Component
 */
class InputTextArea extends React.PureComponent {
    constructor(props) {
        super(props);
        const { value = '' } = this.props;
        this.state = {
            focused: false,
            text: value || '',
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { value } = props;
        const { text } = state;
        if (value !== text) {
            return {
                text: value,
            };
        }
        return null;
    }

    onFocus = () => this.setState({ focused: true });

    onBlur = (event) => {
        const { onBlur = () => null } = this.props;
        this.setState({ focused: false });
        onBlur(event);
    };

    onChange = (e) => {
        const { onChange = () => null } = this.props;
        this.setState({ text: e.target.value });
        if (onChange) {
            onChange(e.target.value);
        }
    };

    onClearHandler = () => {
        this.clearInput();
        this.focus();
    };

    focus() {
        if (this.textarea) {
            this.textarea.focus();
        }
    }

    clearInput() {
        const { onClearClick = () => null } = this.props;
        this.setState({ text: '' }, () => {
            onClearClick();
        });
    }

    render() {
        const {
            className = '',
            placeholder = '',
            id = '',
            isClearable = true,
            readOnly,
            hasError,
            minRows = 1,
            maxRows = 10,
            dataTest = '',
            ...rest
        } = this.props;
        const { text, focused } = this.state;

        const parentClassNames = ['input-textarea-wrapper'];
        if (focused) {
            parentClassNames.push('input-textarea--focus');
        }
        if (readOnly) {
            parentClassNames.push('input-textarea-readonly');
        }
        if (hasError) {
            parentClassNames.push('input-error');
        }
        if (isClearable) {
            parentClassNames.push('input-textarea__with-icon');
        }

        let classNames = ['input-textarea'];
        if (className) {
            classNames = classNames.concat(className);
        }

        return (
            <div className={parentClassNames.join(' ')}>
                <TextareaAutosize
                    {...rest}
                    inputRef={(tag) => {
                        this.textarea = tag;
                    }}
                    id={id}
                    type="textarea"
                    className={classNames.join(' ')}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    maxRows={maxRows}
                    minRows={minRows}
                    value={text}
                    data-test={dataTest}
                />
                <div className="input-textarea-icon">
                    {isClearable && !readOnly && text.length > 0 && (
                        <ButtonInputClear onClick={this.onClearHandler} tabIndex="-1">
                            <i className="input-textarea-icon__lock">
                                <Close color={CFM_VOLCANO} />
                            </i>
                        </ButtonInputClear>
                    )}
                </div>
            </div>
        );
    }
}

InputTextArea.propTypes = {
    /** Description of prop "value". */
    value: PropTypes.string,
    /** Description of prop "placeholder". */
    placeholder: PropTypes.string,
    /** Disable input */
    disabled: PropTypes.bool,
    /** Class name property */
    className: PropTypes.string,
    /** input id */
    id: PropTypes.string,
    /** onchange */
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    isClearable: PropTypes.bool,
    onClearClick: PropTypes.func,
    hasError: PropTypes.bool,
    minRows: PropTypes.number,
    maxRows: PropTypes.number,
    readOnly: PropTypes.bool,
    dataTest: PropTypes.string,
};

export default InputTextArea;
